
import generic from '@components/atoms/SelectedComponent.vue';
import tween from '@components/selected/tweenSelected.vue'

export default {
generic,
tween,
}
